import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import AssistantIcon from '@mui/icons-material/Assistant';
import AvTimerIcon from '@mui/icons-material/AvTimer';
import BackHandOutlinedIcon from '@mui/icons-material/BackHandOutlined';
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import CellTowerIcon from '@mui/icons-material/CellTowerRounded';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import ClosedCaptionsIcon from '@mui/icons-material/ClosedCaption';
import ClosedCaptionsOutlinedIcon from '@mui/icons-material/ClosedCaptionOffOutlined';
import CommitIcon from '@mui/icons-material/Commit';
import ConstructionIcon from '@mui/icons-material/ConstructionRounded';
import EventIcon from '@mui/icons-material/Event';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import FullscreenOutlinedIcon from '@mui/icons-material/FullscreenOutlined';
import GroupsFilledIcon from '@mui/icons-material/Groups';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import HearingIcon from '@mui/icons-material/Hearing';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import InsertEmoticonOutlinedIcon from '@mui/icons-material/InsertEmoticonOutlined';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import LanguageIcon from '@mui/icons-material/Language';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import PauseIcon from '@mui/icons-material/Pause';
import PauseOutlinedIcon from '@mui/icons-material/PauseOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import PersonOffOutlinedIcon from '@mui/icons-material/PersonOffOutlined';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import RocketOutlinedIcon from '@mui/icons-material/RocketOutlined';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import SpeedIcon from '@mui/icons-material/Speed';
import StopIcon from '@mui/icons-material/Stop';
import SupportOutlinedIcon from '@mui/icons-material/SupportOutlined';
import TagOutlinedIcon from '@mui/icons-material/TagOutlined';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import UnpublishedOutlinedIcon from '@mui/icons-material/UnpublishedOutlined';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import VolumeDownIcon from '@mui/icons-material/VolumeDown';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import WifiIcon from '@mui/icons-material/Wifi';
import { createSvgIcon } from 'common/theme/utils';

import Add from './Add.svg?react';
import ArrowRight from './ArrowRight.svg?react';
import ArrowUp from './ArrowUp.svg?react';
import AutoRenew from './AutoRenew.svg?react';
import BarChart from './BarChart.svg?react';
import BookSpark from './BookSpark.svg?react';
import BorderColor from './BorderColor.svg?react';
import Calendar from './Calendar.svg?react';
import CancelPresentationFilled from './CancelPresentationFilled.svg?react';
import ChartSelect from './ChartSelect.svg?react';
import Chat from './Chat.svg?react';
import Check from './Check.svg?react';
import CheckFilled from './CheckFilled.svg?react';
import ChevronDown from './ChevronDown.svg?react';
import ChevronLeft from './ChevronLeft.svg?react';
import ChevronRight from './ChevronRight.svg?react';
import ChevronUp from './ChevronUp.svg?react';
import Close from './Close.svg?react';
import Copy from './Copy.svg?react';
import Delete from './Delete.svg?react';
import DoubleArrowLeft from './DoubleArrowLeft.svg?react';
import Download from './Download.svg?react';
import DragIndicator from './DragIndicator.svg?react';
import Duplicate from './Duplicate.svg?react';
import Edit from './Edit.svg?react';
import EmojiFilled from './EmojiFilled.svg?react';
import EmojiOutlined from './EmojiOutlined.svg?react';
import ErrorFilled from './ErrorFilled.svg?react';
import ErrorOutlined from './ErrorOutlined.svg?react';
import ExitToApp from './ExitToApp.svg?react';
import Filter from './Filter.svg?react';
import Forum from './Forum.svg?react';
import FramePersonOff from './FramePersonOff.svg?react';
import FramePersonOn from './FramePersonOn.svg?react';
import GoogleColoured from './GoogleColoured.svg?react';
import GroupOutlined from './GroupOutlined.svg?react';
import HandFilled from './HandFilled.svg?react';
import HandOutlined from './HandOutlined.svg?react';
import HelpOutlined from './HelpOutlined.svg?react';
import HomeOutlined from './HomeOutlined.svg?react';
import Image from './Image.svg?react';
import InfoFilled from './InfoFilled.svg?react';
import InfoOutlined from './InfoOutlined.svg?react';
import Insights from './Insights.svg?react';
import Link from './Link.svg?react';
import Lock from './Lock.svg?react';
import Login from './Login.svg?react';
import Logout from './Logout.svg?react';
import Menu from './Menu.svg?react';
import MicrophoneOffFilled from './MicrophoneOffFilled.svg?react';
import MicrophoneOffOutlined from './MicrophoneOffOutlined.svg?react';
import MicrophoneOn from './MicrophoneOn.svg?react';
import MoreHorizontal from './MoreHorizontal.svg?react';
import MoreVertical from './MoreVertical.svg?react';
import OutlookColoured from './OutlookColoured.svg?react';
import Participants from './Participants.svg?react';
import PersonOutlined from './PersonOutlined.svg?react';
import PhoneFilled from './PhoneFilled.svg?react';
import Pin from './Pin.svg?react';
import PlayCircle from './PlayCircle.svg?react';
import PowerSettings from './PowerSettings.svg?react';
import PresentToAll from './PresentToAll.svg?react';
import RadioButtonChecked from './RadioButtonChecked.svg?react';
import RaisedHand from './RaisedHand.svg?react';
import RecordVoiceOver from './RecordVoiceOver.svg?react';
import Replay from './Replay.svg?react';
import Restart from './Restart.svg?react';
import ScreenShare from './ScreenShare.svg?react';
import Search from './Search.svg?react';
import Send from './Send.svg?react';
import Settings from './Settings.svg?react';
import SettingsAccount from './SettingsAccount.svg?react';
import SettingsFilled from './SettingsFilled.svg?react';
import Share from './Share.svg?react';
import ShareScreen from './ShareScreen.svg?react';
import Speaker from './Speaker.svg?react';
import Star from './Star.svg?react';
import TriangleArrowDown from './TriangleArrowDown.svg?react';
import TriangleArrowUp from './TriangleArrowUp.svg?react';
import Upload from './Upload.svg?react';
import Videocam from './Videocam.svg?react';
import VideocamOff from './VideocamOff.svg?react';
import VideocamOutlined from './VideocamOutlined.svg?react';
import VisibilityLock from './VisibilityLock.svg?react';
import VisibilityOff from './VisibilityOff.svg?react';
import VisibilityOn from './VisibilityOn.svg?react';
import VoiceOverOff from './VoiceOverOff.svg?react';
import WarningFilled from './WarningFilled.svg?react';
import WarningOutlined from './WarningOutlined.svg?react';
import WifiBad from './WifiBad.svg?react';
import WifiMedium from './WifiMedium.svg?react';
import WifiOk from './WifiOk.svg?react';

export {
  AccountCircleIcon,
  ArticleOutlinedIcon,
  AssignmentIcon,
  AssignmentOutlinedIcon,
  AssistantIcon,
  AvTimerIcon,
  BackHandOutlinedIcon,
  BarChartRoundedIcon,
  CalendarMonthIcon,
  CalendarMonthOutlinedIcon,
  CellTowerIcon,
  EventIcon,
  HeadphonesIcon,
  HearingIcon,
  WifiIcon,
  ChatBubbleOutlineIcon,
  CheckBoxOutlinedIcon,
  ClosedCaptionsIcon,
  ClosedCaptionsOutlinedIcon,
  CommitIcon,
  ConstructionIcon,
  FormatListNumberedIcon,
  ForumOutlinedIcon,
  FullscreenOutlinedIcon,
  Groups2OutlinedIcon,
  GroupsFilledIcon,
  GroupsOutlinedIcon,
  HubOutlinedIcon,
  InsertEmoticonOutlinedIcon,
  LabelOutlinedIcon,
  LanguageIcon,
  LogoutOutlinedIcon,
  ManageAccountsOutlinedIcon,
  PauseIcon,
  PauseOutlinedIcon,
  PeopleAltOutlinedIcon,
  PersonAddAlt1OutlinedIcon,
  PersonAddAltOutlinedIcon,
  PersonOffOutlinedIcon,
  PlayArrowIcon,
  PlayArrowOutlinedIcon,
  QueryStatsOutlinedIcon,
  QuestionAnswerOutlinedIcon,
  RocketOutlinedIcon,
  SettingsInputAntennaIcon,
  SettingsOutlinedIcon,
  SpeedIcon,
  StopIcon,
  SupportOutlinedIcon,
  TagOutlinedIcon,
  TimelineOutlinedIcon,
  UnpublishedOutlinedIcon,
  VerifiedOutlinedIcon,
  VolumeDownIcon,
  VolumeUpIcon,
};
export const AddIcon = createSvgIcon(Add, 'Add');
export const ArrowRightIcon = createSvgIcon(ArrowRight, 'ArrowRight');
export const AutoRenewIcon = createSvgIcon(AutoRenew, 'AutoRenew');
export const BarChartIcon = createSvgIcon(BarChart, 'BarChart');
export const BookSparkIcon = createSvgIcon(BookSpark, 'BookSpark');
export const CalendarIcon = createSvgIcon(Calendar, 'Calendar');
export const CancelPresentationFilledIcon = createSvgIcon(CancelPresentationFilled, 'CancelPresentationFilled');
export const ChartSelectIcon = createSvgIcon(ChartSelect, 'ChartSelect');
export const ChatIcon = createSvgIcon(Chat, 'Chat');
export const CheckFilledIcon = createSvgIcon(CheckFilled, 'CheckFilled');
export const CheckIcon = createSvgIcon(Check, 'Check');
export const ChevronDownIcon = createSvgIcon(ChevronDown, 'ChevronDown');
export const ChevronLeftIcon = createSvgIcon(ChevronLeft, 'ChevronLeft');
export const ChevronRightIcon = createSvgIcon(ChevronRight, 'ChevronRight');
export const ChevronUpIcon = createSvgIcon(ChevronUp, 'ChevronUp');
export const CloseIcon = createSvgIcon(Close, 'Close');
export const CopyIcon = createSvgIcon(Copy, 'Copy');
export const DeleteIcon = createSvgIcon(Delete, 'Delete');
export const DoubleArrowLeftIcon = createSvgIcon(DoubleArrowLeft, 'DoubleArrowLeft');
export const DownloadIcon = createSvgIcon(Download, 'Download');
export const DragIndicatorIcon = createSvgIcon(DragIndicator, 'DragIndicator');
export const DuplicateIcon = createSvgIcon(Duplicate, 'Duplicate');
export const EditIcon = createSvgIcon(Edit, 'Edit');
export const EmojiFilledIcon = createSvgIcon(EmojiFilled, 'EmojiFilled');
export const EmojiOutlinedIcon = createSvgIcon(EmojiOutlined, 'EmojiOutlined');
export const ErrorFilledIcon = createSvgIcon(ErrorFilled, 'ErrorFilled');
export const ErrorOutlinedIcon = createSvgIcon(ErrorOutlined, 'ErrorOutlined');
export const ExitToAppIcon = createSvgIcon(ExitToApp, 'ExitToApp');
export const FilterIcon = createSvgIcon(Filter, 'Filter');
export const ForumIcon = createSvgIcon(Forum, 'Forum');
export const FramePersonIcon = createSvgIcon(FramePersonOn, 'FramePerson');
export const FramePersonOffIcon = createSvgIcon(FramePersonOff, 'FramePersonOff');
export const HandFilledIcon = createSvgIcon(HandFilled, 'HandFilled');
export const HandOutlinedIcon = createSvgIcon(HandOutlined, 'HandOutlined');
export const HelpOutlinedIcon = createSvgIcon(HelpOutlined, 'HelpOutlined');
export const HomeOutlinedIcon = createSvgIcon(HomeOutlined, 'HomeOutlined');
export const ImageIcon = createSvgIcon(Image, 'Image');
export const InfoFilledIcon = createSvgIcon(InfoFilled, 'InfoFilled');
export const InfoOutlinedIcon = createSvgIcon(InfoOutlined, 'InfoOutlined');
export const InsightsIcon = createSvgIcon(Insights, 'Insights');
export const LinkIcon = createSvgIcon(Link, 'Link');
export const LockIcon = createSvgIcon(Lock, 'Lock');
export const LoginIcon = createSvgIcon(Login, 'Login');
export const LogoutIcon = createSvgIcon(Logout, 'Logout');
export const MenuIcon = createSvgIcon(Menu, 'Menu');
export const MicrophoneOffOutlinedIcon = createSvgIcon(MicrophoneOffOutlined, 'MicrophoneOffOutlined');

export const GoogleColouredIcon = createSvgIcon(GoogleColoured, 'GoogleColoured');
export const OutlookColouredIcon = createSvgIcon(OutlookColoured, 'OutlookColoured');
export const MicrophoneOffFilledIcon = createSvgIcon(MicrophoneOffFilled, 'MicrophoneOffFilled');
export const MicrophoneOnIcon = createSvgIcon(MicrophoneOn, 'MicrophoneOn');
export const MoreHorizontalIcon = createSvgIcon(MoreHorizontal, 'MoreHorizontal');
export const MoreVerticalIcon = createSvgIcon(MoreVertical, 'MoreVertical');
export const PhoneFilledIcon = createSvgIcon(PhoneFilled, 'PhoneFilled');
export const PinIcon = createSvgIcon(Pin, 'Pin');
export const PlayCircleIcon = createSvgIcon(PlayCircle, 'PlayCircle');
export const PowerSettingsIcon = createSvgIcon(PowerSettings, 'Power');
export const PresentToAllIcon = createSvgIcon(PresentToAll, 'PresentToAll');
export const RadioButtonCheckedIcon = createSvgIcon(RadioButtonChecked, 'RadioButtonChecked');
export const RaisedHandIcon = createSvgIcon(RaisedHand, 'RaisedHand');
export const ReplayIcon = createSvgIcon(Replay, 'Replay');
export const ScreenShareIcon = createSvgIcon(ScreenShare, 'ScreenShare');
export const SendIcon = createSvgIcon(Send, 'Send');
export const SearchIcon = createSvgIcon(Search, 'Search');
export const SettingsAccountIcon = createSvgIcon(SettingsAccount, 'SettingsAccount');
export const SettingsFilledIcon = createSvgIcon(SettingsFilled, 'SettingsFilled');
export const SettingsIcon = createSvgIcon(Settings, 'Settings');
export const ShareIcon = createSvgIcon(Share, 'Share');
export const ShareScreenIcon = createSvgIcon(ShareScreen, 'ShareScreen');
export const SpeakerIcon = createSvgIcon(Speaker, 'Speaker');
export const StarIcon = createSvgIcon(Star, 'Star');
export const TriangleArrowDownIcon = createSvgIcon(TriangleArrowDown, 'TriangleArrowDown');
export const TriangleArrowUpIcon = createSvgIcon(TriangleArrowUp, 'TriangleArrowUp');
export const UploadIcon = createSvgIcon(Upload, 'Upload');
export const VideocamIcon = createSvgIcon(Videocam, 'Videocam');
export const VideocamOffIcon = createSvgIcon(VideocamOff, 'VideocamOff');
export const VideocamOutlinedIcon = createSvgIcon(VideocamOutlined, 'VideocamOutlined');
export const VisibilityOffIcon = createSvgIcon(VisibilityOff, 'VisibilityOff');
export const VisibilityOnIcon = createSvgIcon(VisibilityOn, 'VisibilityOn');
export const VisibilityLockIcon = createSvgIcon(VisibilityLock, 'VisibilityLock');
export const VoiceOverOffIcon = createSvgIcon(VoiceOverOff, 'VoiceOverOff');
export const WarningFilledIcon = createSvgIcon(WarningFilled, 'WarningFilled');
export const WarningOutlinedIcon = createSvgIcon(WarningOutlined, 'WarningOutlined');
export const RecordVoiceOverIcon = createSvgIcon(RecordVoiceOver, 'RecordVoiceOver');
export const PersonOutlinedIcon = createSvgIcon(PersonOutlined, 'PersonOutlined');
export const GroupOutlinedIcon = createSvgIcon(GroupOutlined, 'GroupOutlined');
export const ArrowUpIcon = createSvgIcon(ArrowUp, 'ArrowUp');
export const BorderColorIcon = createSvgIcon(BorderColor, 'BorderColor');
export const WifiBadIcon = createSvgIcon(WifiBad, 'WifiBad');
export const WifiMediumIcon = createSvgIcon(WifiMedium, 'WifiMedium');
export const WifiOkIcon = createSvgIcon(WifiOk, 'WifiOk');
export const RestartIcon = createSvgIcon(Restart, 'Restart');
export const ParticipantsIcon = createSvgIcon(Participants, 'Participants');
